import { motion } from "framer-motion";
import React from "react";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProjectContentBox = (props) => {
  const { title, projectURL, githubURL, description, thumbnail } =
    props.content;

  return (
    <motion.li
      initial={{ opacity: 0 }}
      whileInView={{
        opacity: 1,
      }}
      transition={{ ease: "easeOut", duration: 0.5 }}
      viewport={{ once: true }}
      className="group bg-[#31313F] p-4 md:p-16 lg:p-8 mb-5 lg:mb-10 ml-0 transition-colors flex flex-col duration-600 border-[4px] border-[#5A5A6E] rounded-lg"
    >
      <div className="flex justify-between items-center pb-4 mb-2">
        <h1 className="text-[#FFFFFF] text-[12px] lg:text-[20px] font-bold">
          {title}
        </h1>
        <div className="flex gap-2 lg:gap-4">
          {projectURL && (
            <a
              href={projectURL}
              target="_blank"
              rel="noreferrer"
              className="text-neutral-300 hover:text-[#c199e5e0] transition-colors text-[12px] lg:text-[20px]"
            >
              <FontAwesomeIcon icon={faLink} />
            </a>
          )}
          {githubURL && (
            <a
              href={githubURL}
              target="_blank"
              rel="noreferrer"
              className="text-neutral-300 hover:text-[#c199e5e0] transition-colors text-[12px] lg:text-[20px]"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
          )}
        </div>
      </div>
      <div className="flex flex-col md:flex-col lg:flex-row justify-between gap-4 items-center md:space-y-4 lg:space-y-0 lg:space-x-4 mb-0 lg:mb-8">
        <img
          src={thumbnail}
          alt={title}
          className="object-contain w-full lg:w-1/2 h-auto lg:h-1/2"
        />
        <div className="flex flex-col space-y-2">
          <ul className="lg:text-left md:text-left text-[8px] md:text-[12px] text-neutral-300 list-disc list-inside">
            {description.map((point, index) => (
              <li key={index} className="mb-4">
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </motion.li>
  );
};

export default ProjectContentBox;
